import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNounprojectComponent } from './simple-icons-nounproject.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNounprojectComponent ],
    exports:      [ SimpleIconsNounprojectComponent ],
    bootstrap:    []
})
export class SimpleIconsNounprojectModule {}
